
// --- Vue & Template imports ---
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

// --- Models ---
import { Vehicle, WorkshopSummary } from '@/models/Vehicle.model';

@Component
export default class TypeIndicator extends Vue {
  @Prop() item!: Vehicle | WorkshopSummary;
  @Prop() typeField: string | undefined;
}
